<template>
  <button
    class="cancel"
    :class="{ 'cancel--light': isLight }"
    type="button"
    @click="$emit('click')"
  />
</template>
<script>
  export default {
    props: {
      isLight: {
        type: Boolean,
        default: false
      }
    }
  };
</script>

<style lang="scss">
	@import "../../styles/shared/shared";
  $cancel-size: 1em;
  $cancel-width: 2px;
  $cancel-color: $stone;
  $cancel-color-light: $white;

  .cancel {
    position: relative;
    width: $cancel-size;
    height: $cancel-size;
    opacity: 0.6;
    background: none;
    box-shadow: none;
    border: none;
    outline: none;
    cursor: pointer;
    transition: .15s ease;
    &:hover {
      opacity: 1;
    }
    &:before,
    &:after {
      position: absolute;
      left: calc((#{$cancel-size}/2) - (#{$cancel-width}/2));
      top: 0;
      content: ' ';
      height: calc(#{$cancel-size} + (#{$cancel-width}/2));
      width: $cancel-width;
      background-color: $cancel-color;
      transform-origin: center;
    }
    &:before {
      transform: rotate(45deg);
    }
    &:after {
      transform: rotate(-45deg);
    }
    &:focus {
      outline: none;
    }
    &--light {
      &:before,
      &:after {
        background-color: $cancel-color-light;
      }
    }
  }

</style>
